(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('[data-litq-registration-origin]').forEach((frame) => {
      if (frame.dataset.litqRegistrationHeightReady) return;
      let origin;
      try {
        origin = new URL(frame.dataset.litqRegistrationOrigin).origin;
      } catch {
        return;
      }
      frame.dataset.litqRegistrationHeightReady = 'true';
      let signatureScrollTop = 0;
      const firstVisit = () => window.OriginariaVisit?.firstVisitedOn || new Date().toISOString().slice(0, 10);
      const sendFirstVisit = () => frame.contentWindow?.postMessage({ type: 'originaria-first-visit', firstVisitedOn: firstVisit() }, origin);
      frame.addEventListener('load', sendFirstVisit);
      window.addEventListener('message', (event) => {
        if (!frame.isConnected || event.origin !== origin || event.source !== frame.contentWindow) return;
        if (event.data?.type === 'originaria-guestbook-ready') {
          sendFirstVisit();
          return;
        }
        if (event.data?.type === 'originaria-guestbook-signature' && typeof event.data.open === 'boolean') {
          const dialog = frame.closest('[data-litq-registration-dialog]');
          if (dialog?.open) {
            const body = dialog.querySelector('.ac-litq__registration-body');
            if (event.data.open && !dialog.classList.contains('is-signing-guestbook')) signatureScrollTop = body?.scrollTop || 0;
            dialog.classList.toggle('is-signing-guestbook', event.data.open);
            if (!event.data.open && body) requestAnimationFrame(() => { body.scrollTop = signatureScrollTop; });
          }
          return;
        }
        if (event.data?.type === 'litq-registration-language-ready') {
          const language = window.LITQI18n?.language || frame.closest('.ac-litq')?.dataset.litqLanguage || 'en';
          frame.contentWindow?.postMessage({ type: 'litq-language-change', language }, origin);
          return;
        }
        if (event.data?.type !== 'litq-registration-height') return;
        const height = Number(event.data.height);
        if (Number.isFinite(height) && height > 100 && height < 8000) frame.height = String(Math.ceil(height) + 20);
      });
    });

    scope.querySelectorAll('[data-litq-registration-dialog]').forEach((dialog) => {
      if (dialog.dataset.litqRegistrationReady || typeof dialog.showModal !== 'function' || typeof dialog.close !== 'function') return;
      const root = dialog.closest('.ac-litq');
      const frame = dialog.querySelector('[data-litq-registration-src]');
      const close = dialog.querySelector('[data-litq-registration-close]');
      const primary = root?.querySelector('[data-litq-registration-open]');
      if (!root || !frame || !close || !primary) return;
      dialog.dataset.litqRegistrationReady = 'true';
      const fallbacks = root.querySelectorAll('[data-litq-registration-fallback]');
      const triggers = root.querySelectorAll('[data-litq-registration-open], a[href="#registration"]');
      let opener = primary;

      const open = (trigger = primary) => {
        if (!dialog.isConnected) return false;
        if (dialog.open) return true;
        opener = trigger;
        try {
          dialog.showModal();
        } catch {
          primary.hidden = true;
          fallbacks.forEach((fallback) => { fallback.hidden = false; });
          return false;
        }
        if (!frame.hasAttribute('src')) {
          const source = new URL(frame.dataset.litqRegistrationSrc, location.href);
          source.searchParams.set('firstVisit', window.OriginariaVisit?.firstVisitedOn || new Date().toISOString().slice(0, 10));
          frame.src = source.href;
        }
        return true;
      };

      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.addEventListener('click', (event) => {
          if (open(trigger)) event.preventDefault();
        });
      });
      close.addEventListener('click', () => dialog.close());

      // A drag starting in the form or ending inside the dialog must not dismiss it.
      const outside = (event) => {
        const rect = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      };
      let backdropPointer;
      dialog.addEventListener('pointerdown', (event) => {
        backdropPointer = outside(event) ? event.pointerId : undefined;
      });
      dialog.addEventListener('pointerup', (event) => {
        if (backdropPointer !== undefined && backdropPointer === event.pointerId && outside(event)) dialog.close();
        backdropPointer = undefined;
      });
      dialog.addEventListener('pointercancel', () => { backdropPointer = undefined; });
      dialog.addEventListener('close', () => {
        backdropPointer = undefined;
        dialog.classList.remove('is-signing-guestbook');
        frame.contentWindow?.postMessage({ type: 'originaria-guestbook-signature-close' }, new URL(frame.dataset.litqRegistrationOrigin).origin);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      });

      primary.hidden = false;
      fallbacks.forEach((fallback) => { fallback.hidden = true; });
      const openFromHash = () => {
        if (window.location.hash === '#registration') open();
      };
      window.addEventListener('hashchange', openFromHash);
      openFromHash();
    });
  };

  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
